import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList } from './props-list';

const DEFAULT_MODIFIERS = [];
const DEFAULT_TAG = 'h2';

const SectionDivider = ({ modifiers = DEFAULT_MODIFIERS, children, title, description, titleTag = DEFAULT_TAG }) => {
  const classNames = getClassNames('c-section-divider', modifiers);
  const Tag = titleTag;

  return (
    <section className={classNames}>
      {children}
      {title && <Tag className="c-section-divider__title" dangerouslySetInnerHTML={{ __html: title }} />}
      {description && (
        <div className="c-section-divider__description" dangerouslySetInnerHTML={{ __html: description }} />
      )}
    </section>
  );
};

SectionDivider.propTypes = {
  titleTag: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  children: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default SectionDivider;
